import { useSnackbarStack } from '@superdispatch/ui';
import { useCallback } from 'react';
import { useAPIMutation } from 'shared/api/APIMutation';
import { AddLoadDTO } from '../data/LoadDTO';
import { useLoadsContext } from '../data/LoadsContext';

interface UseAddLoadDispatchSheetParseOptions {
  onParsed: (parsed: AddLoadDTO) => void;
}

export function useAddLoadDispatchSheetParse({
  onParsed,
}: UseAddLoadDispatchSheetParseOptions) {
  const { addSnackbar } = useSnackbarStack();
  const { loadsAPI } = useLoadsContext();

  const { mutate, isPending } = useAPIMutation(
    async (file: File) => {
      const [parsed] = await loadsAPI.parseDispatchSheet(file);

      if (!parsed) {
        throw new Error('Failed to parse dispatch sheet');
      }

      return {
        meta: { code: 200, request_id: '' },
        user_message: '',
        data: parsed,
      };
    },
    {
      onSuccess: (response) => {
        onParsed(response.data);
        addSnackbar(
          'Dispatch sheet parsed. Review the form and save your load.',
          {
            variant: 'success',
          },
        );
      },
      onError: (error) => {
        addSnackbar(error.message || 'Failed to parse dispatch sheet', {
          variant: 'error',
        });
      },
    },
  );

  const parseDispatchSheet = useCallback(
    (file: File) => {
      mutate(file);
    },
    [mutate],
  );

  return {
    isParsingDispatchSheet: isPending,
    parseDispatchSheet,
  };
}
